import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['justselect', 'justselectList']

  openList() {
    console.log('toto')
    this.justselectListTarget.classList.toggle('d-block')
  }
}